import React, { useContext, useEffect, useState } from "react";
import { FilterContext } from "../../context/Filter";
import { fetchPvinData, fetchPvinToken } from "../newPivin/PvinKip";
import WaterMark from "../../components/WaterMark";
import Header from "../../components/Header/Header";
import Search from "../../components/CustSearch/Search";
import CustomerDetailsCard from "../newPivin/CustomerDetailsCard";
import FleetSummary from "../newPivin/FleetSummary";
import TataCareCuponCard from "../newPivin/TataCareCuponCard";
import SubscriptionDetails from "../newPivin/SubscriptionDetails";
import ServiceSummary from "../newPivin/Servicesumtable";
import FleetDetails from "../newPivin/Fleetpvintable";
import FinancierSummary from "../newPivin/Finnanciersummary";
import ApplicationSummary from "../newPivin/Appsummarytb";
import CustomerComplaints from "../newPivin/Customercomptable";
import RenewalReminders from "../newPivin/Renewalremindertb";
import Last5ServiceDetails from "../newPivin/Lastfivetable";
import SubscriptionDetailstb from "../newPivin/Subscriptiondetailstb";
import Accordianpvin from "../newPivin/Accordianpvinn";
import { useSearchParams } from "react-router-dom";

const PivinIndex = () => {
  const [pvinToken, setPvinToken] = useState(null);
  const [pvinData, setPvinData] = useState(null); //
  const { superArn: parArn, childArn } = useContext(FilterContext);
  const [searchParams] = useSearchParams();
  const selectedArnValue = searchParams.get("vin");

  // console.log(parArn, "pvinbt");
  // Fetch Token
  const fetchPvinTokenValues = async () => {
    try {
      const response = await fetchPvinToken();
      const token = response?.data?.access_token;
      if (token) {
        setPvinToken(token);
        // console.log("✅ Token fetched successfully:", token);
        return token;
      } else {
        console.error("No token returned from API");
        return null;
      }
    } catch (error) {
      console.error("Error fetching PVIN token:", error);
      throw error;
    }
  };

  // Fetch Data
  const fetchPvinDataValues = async (token) => {
    try {
      if (!token) return console.error("Token missing, skipping data fetch");

      const response = await fetchPvinData(token, selectedArnValue);
      // console.log("✅ PVIN Data Response:", response);

      setPvinData(response);
    } catch (error) {
      console.error("No data available", error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        const token = await fetchPvinTokenValues();
        await fetchPvinDataValues(token);
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };

    initialize();
  }, [selectedArnValue]);

  return (
    <>
      {process.env.REACT_APP_EGURUUSERNAME === "x-cv-cmp-customer360-service" &&
        process.env.REACT_APP_EGURUPWD === "VZFlJz9PCRBMdslzwC@" ? (
        <div>
          <WaterMark />
          <Header />
          <div className="block md:flex justify-center items-center gap-16 m-2">
            <CustomerDetailsCard data={pvinData || []} />
            <FleetSummary data={pvinData || []} />
            <div className="flex flex-col gap-2">
              <TataCareCuponCard data={pvinData || []} />
              <SubscriptionDetails data={pvinData || []} />
            </div>
          </div>

          <div className="w-96 md:w-full md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
            <ServiceSummary allData={pvinData?.service_summary || []} />
            <FleetDetails data={pvinData?.Fleet_Details || []} />
          </div>

          <div className="w-96 md:w-full lg:grid md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
            <FinancierSummary data={pvinData?.Financier_Summary || []} />
            <ApplicationSummary data={pvinData?.Application_Summary || []} />
          </div>

          <div className="w-96 md:w-full lg:grid md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
            <CustomerComplaints data={pvinData?.Customer_Complaints || []} />
            <RenewalReminders data={pvinData || []} />
          </div>

          <div className="w-96 md:w-full flex flex-col items-center justify-center gap-2">
            <Last5ServiceDetails data={pvinData?.Last_5_Service_Details || []} />
            <SubscriptionDetailstb data={pvinData?.["Subscription Details"] || []} />
            <Accordianpvin data={pvinData?.Fleetedge_Details || []} />
          </div>
        </div>
      ) : (
        <div className="text-center p-6 text-red-600 text-xl font-bold">
          Unauthorized Access
        </div>
      )}
    </>

  );
};

export default PivinIndex;
